import { useEffect, useRef, useState } from 'react';

import { getFileExtension } from 'utils/getFileExtension';

export const useSvgFetch = (url) => {
  const cache = useRef({});
  const [data, setData] = useState(null);

  useEffect(() => {
    // prettier-ignore
    if (!url || !url.length || getFileExtension(url).toLowerCase() !== "svg") return;

    const fetchData = async () => {
      if (cache.current[url]) return setData(cache.current[url]);
      const result = await fetch(url);
      const responseData = await result.text();
      cache.current[url] = responseData;
      return setData(responseData);
    };

    fetchData();
  }, [url]);

  return data;
};
